import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Alerte trésorerie : être prévenu avant la crise, pas pendant | Trezoone',
    description: 'Les alertes de trésorerie vous notifient avant d\'atteindre les seuils critiques. Configurez vos seuils, recevez vos alertes, agissez à temps.',
    canonical: '/alerte-tresorerie',
    keywords: 'alerte trésorerie, alerte solde bancaire, notification trésorerie, surveillance trésorerie, seuil alerte trésorerie',
  },
  hero: {
    tag: 'Alertes trésorerie',
    title: 'Ne découvrez plus les problèmes de trésorerie le jour où ils arrivent.',
    subtitle: 'Les alertes de trésorerie vous notifient à l\'avance. Configurez vos seuils, recevez l\'alerte par email, agissez avant que ça coince.',
    ctaLabel: 'Configurer mes alertes',
  },
  pilierLink: { label: 'Alertes trésorerie (fonctionnalité)', href: '/fonctionnalites/alertes-tresorerie' },
  sections: [
    {
      type: 'explain',
      title: 'Pourquoi les alertes de trésorerie changent tout',
      content: 'La différence entre gérer en urgence et anticiper, c\'est souvent 3 à 6 semaines. C\'est exactement ce que donnent les alertes.',
      items: [
        'Sans alerte : vous découvrez le problème en ouvrant votre application bancaire',
        'Avec alerte : vous êtes notifié quand le solde prévisionnel descend sous un seuil défini',
        'Délai gagné : 3 à 8 semaines pour négocier, décaler, financer ou relancer',
        'Résultat : moins de stress, moins de frais de découvert, meilleure relation bancaire',
      ],
    },
    {
      type: 'example',
      title: 'Exemples d\'alertes utiles à configurer',
      content: 'Voici les alertes les plus précieuses selon votre profil :',
      items: [
        'Alerte solde réel : "Notifier quand le solde bancaire passe sous 5 000 €"',
        'Alerte solde prévisionnel : "Notifier quand le solde prévu dans 30j passe sous 0 €"',
        'Alerte subvention : "Notifier si la subvention CAF n\'est pas reçue au 15 mars"',
        'Alerte créance : "Notifier si la facture #1234 n\'est pas encaissée 10j après l\'échéance"',
        'Alerte récurrente : "Rappeler 15j avant le paiement des cotisations trimestrielles"',
      ],
    },
    {
      type: 'midcta',
      title: 'Votre trésorerie sous surveillance 24h/24 — soyez alerté avant le rouge',
      content: 'Configurez vos seuils une seule fois. Trezoone surveille en continu et vous alerte par email dès qu\'une limite est franchie.',
    },
    {
      type: 'solution',
      title: 'Trezoone : vos alertes de trésorerie personnalisées',
      content: 'Configurez vos alertes en quelques minutes. Recevez-les par email ou notification.',
      items: [
        'Alertes sur solde réel et solde prévisionnel',
        'Alertes sur les subventions en attente',
        'Alertes sur les créances clients en retard',
        'Alertes récurrentes avant les échéances importantes',
        'Envoi par email et notification navigateur',
        'Seuils personnalisables par type d\'alerte',
      ],
    },
    {
      type: 'cluster',
      title: 'Approfondir la gestion de trésorerie',
      links: [
        { label: 'Gestion de trésorerie', href: '/gestion-tresorerie' },
        { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
        { label: 'Suivi trésorerie entreprise', href: '/suivi-tresorerie-entreprise' },
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
        { label: 'Stress test trésorerie', href: '/stress-test-tresorerie' },
        { label: 'Manque de trésorerie', href: '/manque-tresorerie' },
        { label: 'Problème cash flow', href: '/probleme-cash-flow' },
        { label: 'Logiciel trésorerie entreprise', href: '/logiciel-tresorerie-entreprise' },
      ],
    },
    {
      type: 'cta',
      title: 'Configurez vos premières alertes de trésorerie',
      content: 'Essai gratuit 14 jours. Vos alertes sont opérationnelles en 5 minutes.',
    },
  ],
  relatedLinks: [
    { label: 'Alertes trésorerie (détail)', href: '/fonctionnalites/alertes-tresorerie' },
    { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
    { label: 'Suivi trésorerie entreprise', href: '/suivi-tresorerie-entreprise' },
    { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
    { label: 'Manque de trésorerie', href: '/manque-tresorerie' },
    { label: 'Stress test trésorerie', href: '/stress-test-tresorerie' },
    { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
    { label: 'Logiciel trésorerie entreprise', href: '/logiciel-tresorerie-entreprise' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function AlerteTresoreriePage({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
